import React from 'react'

import { ActionIcon } from '@ui/components/ActionIcon'
import { IconButton } from '@ui/components/Button'
import type { IconButtonProps } from '@ui/components/Button'
import { RichIconProps } from '@ui/components/RichIcon'
import { CopyIcon } from '@ui/icons/Copy.icon'

import { CopyLink } from '@shared/components/CopyLink'

interface CopyButtonBaseProps {
  disabled?: boolean
  value?: string | number | null
  successMessage?: string
  tooltipText?: string
  onCopy?: () => void
}

type CopyButtonProps =
  | (CopyButtonBaseProps & {
      variant: 'compact'
      size?: RichIconProps['size']
    })
  | (CopyButtonBaseProps & {
      variant?: 'secondary' | 'ghost'
      size?: IconButtonProps['size']
    })

export const CopyButton: React.FC<CopyButtonProps> = (props) => {
  if (props.variant === 'compact') {
    const { size, ...copyLinkProps } = props

    return (
      <CopyLink {...copyLinkProps}>
        <ActionIcon icon={CopyIcon} size={size} />
      </CopyLink>
    )
  }

  const { variant = 'secondary', size, ...copyLinkProps } = props
  const ButtonComponent = variant === 'ghost' ? IconButton.Ghost : IconButton.Secondary

  return (
    <CopyLink {...copyLinkProps}>
      <ButtonComponent icon={CopyIcon} size={size} />
    </CopyLink>
  )
}
